import {ReactElement} from "react";
import {SectionContainer} from "./SharedComponents";
import {StyledBoxColumn, StyledBoxRow, StyledHeadingVariant, StyledSpan} from "@/shared/StyledComponents";
import {Button, Grid, Typography, useMediaQuery, useTheme} from "@mui/material";
import {ArrowForwardIosOutlined, ArrowForwardOutlined} from "@mui/icons-material";
import {CARD_SHADOW, PD_LG, PD_MD, PD_SM, PD_XLG} from "@/shared/dimens";
import {SERVICE_TYPE_KTM, ServicesDisplayMode, ServicesSectionData} from "../../types";

export function ServicesSection(props: { data: ServicesSectionData }): ReactElement {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));

  const featuredImageUrl = props.data.services[0]?.imageUrl
    || SERVICE_TYPE_KTM.findMetadata(props.data.services[0]?.type)?.imageUrl;

  return <div style={{width: "100%", backgroundColor: "#0D2918"}}>
    <SectionContainer>
      <StyledBoxColumn style={{gap: PD_SM}}>
        {props.data.title
          ? <StyledHeadingVariant default_={3}>{props.data.title}</StyledHeadingVariant>
          : null}
        {props.data.subtitle
          ? <Typography style={{opacity: 0.6, lineHeight: 1.7, maxWidth: 600}}>{props.data.subtitle}</Typography>
          : null}
      </StyledBoxColumn>

      {props.data.displayMode === ServicesDisplayMode.STANDARD
        ? <Grid container>
          {props.data.services.map((service, i) =>
            <Grid key={i} xs={12} sm={6} md={4} style={{display: "flex", padding: PD_MD}}>
              <div style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                borderRadius: 8,
                overflow: "hidden",
                boxShadow: "0 4px 20px rgba(0,0,0,0.4)",
                borderTop: `3px solid ${theme.palette.secondary.main}`,
              }}>
                <img
                  style={{
                    width: "100%",
                    aspectRatio: 16 / 9,
                    background: "#0a2010",
                    objectFit: "cover",
                  }}
                  src={service.imageUrl || SERVICE_TYPE_KTM.findMetadata(service.type)?.imageUrl}
                />
                <StyledBoxColumn style={{flex: 1, padding: PD_LG, gap: PD_MD}}>
                  <StyledBoxColumn style={{gap: PD_SM}}>
                    <Typography variant="h6">{service.title}</Typography>
                    {service.description
                      ? <Typography style={{opacity: 0.6, lineHeight: 1.7}}>
                        {service.description}
                      </Typography>
                      : null}
                  </StyledBoxColumn>
                  {service.link?.text
                    ? <Button
                      href={service.link.url}
                      color="secondary"
                      variant="text"
                      endIcon={<ArrowForwardOutlined/>}
                      style={{alignSelf: "flex-start", marginLeft: -PD_LG}}>
                      {service.link.text}
                    </Button>
                    : null}
                </StyledBoxColumn>
              </div>
            </Grid>
          )}
        </Grid>
        : null}

      {props.data.displayMode === ServicesDisplayMode.COMPACT
        ? <div style={{
          display: "flex",
          flexWrap: md ? "nowrap" : "wrap",
          gap: PD_XLG,
          alignItems: "stretch",
        }}>
          <StyledBoxColumn style={{flex: md ? "0 0 55%" : "0 0 100%", gap: 0}}>
            {props.data.services.map((service, i) =>
              <a key={i} href={service.link.url} style={{textDecoration: "none", color: "inherit"}}>
                <StyledBoxRow style={{
                  alignItems: "center",
                  gap: PD_LG,
                  padding: `${PD_LG}px ${PD_MD}px`,
                  borderBottom: "1px solid rgba(255,255,255,0.08)",
                  borderLeft: `3px solid ${theme.palette.secondary.main}`,
                  transition: "background 0.15s",
                }}>
                  <StyledHeadingVariant default_={5} max={6} style={{flex: 1}}>
                    {service.title}
                  </StyledHeadingVariant>
                  <ArrowForwardIosOutlined style={{
                    fontSize: 15,
                    color: theme.palette.secondary.main,
                    flexShrink: 0,
                  }}/>
                </StyledBoxRow>
              </a>
            )}
          </StyledBoxColumn>

          {md && featuredImageUrl
            ? <div style={{
              flex: "1 0 40%",
              minHeight: 360,
              position: "relative",
              borderRadius: 8,
              overflow: "hidden",
            }}>
              <img
                src={featuredImageUrl}
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center top",
                }}/>
            </div>
            : null}
        </div>
        : null}
    </SectionContainer>
  </div>;
}
